import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, CircularProgress } from '@mui/material';
import AccordionSettings from '../../../../../Components/AccordionSettings';
import commonStyles from '../../../../../commonStyles';
import DropDownSingle from '../../../../../Components/DropDownSingle';
import InputConfig from '../../../../../Components/InputConfig';

import CheckBoxInput from '../../../../../Components/CheckBoxInput';
import DeleteIcon from '@mui/icons-material/Delete';
import { fetchGitBranches } from '../../../../../api/expbDoc';
import { toast } from 'react-toastify';
import CONSTANTS from '../constant.json';

const { CONSUMER_NAMES } = CONSTANTS;
const { MASTER, SR1 } = CONSUMER_NAMES;

let cachedBranches = null;

export const SelectiveRolloutExperimentSection = ({ expbDoc, updateExpbDoc }) => {
	const { consumerConfigs } = expbDoc;
	const commonStyleClasses = commonStyles();
	const [gitBranch, setGitBranch] = useState(cachedBranches || []);
	const [loading, setLoading] = useState(!cachedBranches);

	const fetchBranchesList = async () => {
		try {
			setLoading(true);
			const fetchGitBranchesResponse = await fetchGitBranches();
			const branches = fetchGitBranchesResponse?.data?.data?.branches?.allBranches;

			if (Array.isArray(branches)) {
				cachedBranches = branches;
				setGitBranch(branches);
			}
		} catch (error) {
			const errorMessage = error?.response?.data?.data?.message || error.message;
			toast.error(errorMessage, {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (!cachedBranches) {
			fetchBranchesList();
		}
	}, []);

	const updateConsumerConfig = (key, val, index) => {
		const clonedExpbDoc = structuredClone(expbDoc);
		clonedExpbDoc.consumerConfigs = clonedExpbDoc.consumerConfigs || [];
		clonedExpbDoc.consumerConfigs[index] = clonedExpbDoc.consumerConfigs[index] || {};
		clonedExpbDoc.consumerConfigs[index][key] = val;
		updateExpbDoc(clonedExpbDoc);
	};

	const deleteConsumerConfig = (index) => {
		const clonedExpbDoc = structuredClone(expbDoc);
		clonedExpbDoc.consumerConfigs = clonedExpbDoc.consumerConfigs || [];
		clonedExpbDoc.consumerConfigs.splice(index, 1);
		updateExpbDoc(clonedExpbDoc);
	};

	const addConsumerConfig = () => {
		const clonedExpbDoc = structuredClone(expbDoc);
		clonedExpbDoc.consumerConfigs = clonedExpbDoc.consumerConfigs || [];
		if (clonedExpbDoc.consumerConfigs.length === 2) {
			toast.error('Only 2 Consumer Configs are allowed');
			return;
		}

		clonedExpbDoc.consumerConfigs.push({
			branch: '',
			useDebugBundle: false
		});
		updateExpbDoc(clonedExpbDoc);
	};

	return (
		<Box
			className={commonStyleClasses.basicOutlinedBox}
			style={{ width: '94%', margin: '3rem auto 0 auto', textAlign: 'center' }}
		>
			{/* Show "+ Add Consumer Config" button only if consumerConfigs.length < 2 */}
			{(!consumerConfigs || consumerConfigs.length < 2) && (
				<Button
					variant="contained"
					style={{ marginTop: '2rem' }}
					disabled={loading}
					onClick={addConsumerConfig}
				>
					+ Add Consumer Config
				</Button>
			)}

			{/* Loader */}
			{loading && (
				<Box display="flex" justifyContent="center" alignItems="center" p={4}>
					<CircularProgress />
				</Box>
			)}

			{/* Branches available */}
			{!loading && gitBranch.length > 0 && (
				<>
					{Array.isArray(consumerConfigs) &&
						consumerConfigs.map((consumerConfig, index) => {
							const branch = consumerConfig?.branch?.trim();

							// Handling When No Branch is Selected
							let consumerName = '';
							let title = `consumer - ${index + 1}`;

							if (branch) {
								consumerName = branch?.toUpperCase() === MASTER ? MASTER : SR1;
								title = `${consumerName} - ${branch}`;
							}
							return (
								<AccordionSettings
									key={index}
									label={title}
									accordionStyles={{
										width: '90%',
										margin: '5rem auto',
										boxShadow: 'unset'
									}}
									accordionDetailStyles={{
										backgroundColor: 'white',
										border: '1px solid darkgrey',
										borderTop: '0px'
									}}
								>
									<Grid container spacing={2}>
										<Grid item sm={4}>
											<DropDownSingle
												keyData={`consumerConfig.${index}.branch`}
												label="Branch"
												isObjectEditor={false}
												directValue={consumerConfig?.branch}
												updateDirectValue={(val) => updateConsumerConfig('branch', val, index)}
												list={gitBranch}
											/>
										</Grid>
										<Grid item sm={4}>
											<InputConfig
												isObjectEditor={false}
												directValue={consumerName}
												updateDirectValue={(val) => {}}
												editable={false}
												label="Consumer Name"
											/>
										</Grid>
										<Grid item sm={4}>
											<CheckBoxInput
												keyData={`consumerConfig.${index}.useDebugBundle`}
												label="Use Debug Bundle"
												isObjectEditor={false}
												directValue={consumerConfig.useDebugBundle}
												updateDirectValue={(val) =>
													updateConsumerConfig('useDebugBundle', val, index)
												}
												containerStyles={{
													marginTop: '3rem',
													marginLeft: '8rem'
												}}
											/>
										</Grid>
										<Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
											<DeleteIcon
												color="primary"
												onClick={() => deleteConsumerConfig(index)}
												className={commonStyleClasses.icon}
											/>
										</Grid>
									</Grid>
								</AccordionSettings>
							);
						})}
				</>
			)}

			{/* No branches */}
			{!loading && gitBranch.length === 0 && (
				<Box p={4} color="gray">
					No branches available
				</Box>
			)}
		</Box>
	);
};
